import { LIMPAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM } from '../types'

export default function limparReservasExcessoBagagem () {
  return {
    type: LIMPAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM
  }
}